import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useMergeRefs } from '@floating-ui/react';
import { useTimeout } from '../../hooks/useTimeout';
import { useStyles } from '../../hooks/useStyles';
import { SnackbarContent } from '../SnackbarContent';
import { Base } from '../Base';
import { snackbarStyles } from './Snackbar.styles';
import { snackbarTheme } from './Snackbar.stylex';
export const Snackbar = forwardRef(function Snackbar(props, forwardedRef) {
    const { styles, sx, open, horizontalOrigin = 'center', autoHideDuration, onClose, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'Snackbar',
        styles: [snackbarStyles, styles],
    });
    useTimeout(() => onClose?.(), open ? (autoHideDuration ?? null) : null);
    const nodeRef = useRef(null);
    const handleRef = useMergeRefs([nodeRef, forwardedRef]);
    return (_jsx(CSSTransition, { nodeRef: nodeRef, in: open, timeout: 550, classNames: {
            enter: getStyles('animation$enter').className,
            enterActive: getStyles('animation$enterActive').className,
            exitActive: getStyles('animation$exitActive').className,
        }, unmountOnExit: true, children: _jsx(Base, { sx: [
                snackbarTheme,
                globalStyles,
                combineStyles('host', horizontalOrigin === 'left'
                    ? 'host$left'
                    : horizontalOrigin === 'center'
                        ? 'host$center'
                        : undefined),
                sx,
            ], children: _jsx(SnackbarContent, { sx: combineStyles('snackbarContent'), ...other, ref: handleRef, onClose: onClose }) }) }));
});
